import script from "./CalendarDay.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalendarDay.vue?vue&type=script&lang=ts&setup=true"

const cssModules = {}
import style0 from "./CalendarDay.vue?vue&type=style&index=0&id=004a136f&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__